import Monitors from './Monitor'

export default Monitors
